import { apiPost } from './apiClient';
import { addReportToServer, secondsToHMS } from '../functions/sendReport';
import { store } from '../store';
import { setReportId } from '../store/authSlice';

/**
 * PHP flow: checkcoins → savedata → thank-you.
 * Hub points + ExtraMile report only on first attempt (UPDATE existing reportId).
 */
export async function finishGame({ user, gameKey, score, elapsedSeconds = 0 }) {
  const time = secondsToHMS(elapsedSeconds);
  const check = await apiPost('/game/checkCoins', {
    userId: user.userId,
    gameKey,
    score,
  });

  const saved = await apiPost('/game/saveScore', {
    userId: user.userId,
    gameKey,
    score,
    time,
  });

  const alreadyPlayed = Boolean(check.alreadyPlayed);
  const coinsEarned = alreadyPlayed ? 0 : Math.max(0, Number(check.coinsEarned) || 0);

  if (!alreadyPlayed) {
    const prefer =
      saved.reportid || user.reportId || store.getState().auth.user?.reportId || null;
    await addReportToServer(
      { ...user, reportId: prefer },
      {
        points: saved.coins_left ?? coinsEarned,
        reportTime: time,
        answers: [gameKey, String(score)],
        preferReportId: prefer,
        onReportId: (id) => store.dispatch(setReportId(id)),
      }
    );
  }

  return {
    coinsEarned,
    coins_left: saved.coins_left,
    alreadyPlayed,
    reportid: saved.reportid || user.reportId || null,
  };
}
